import GetStartedModal from './GetStartedModal';
import connect from './connect';

export default connect(GetStartedModal);



// WEBPACK FOOTER //
// ./src/components/GetStartedModal/index.js